/**
 * Gets the latest (first) version from an array of application versions.
 * Versions are expected to be pre-sorted with the latest version first.
 *
 * @param versions - Array of application versions
 * @returns The first version in the array, or undefined if the array is empty
 */ export function getLatestAppVersion(versions) {
    return versions.length ? versions[0] : undefined;
}
